import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import StockEntry from "@/pages/StockEntry";
import EtaEntry from "@/pages/EtaEntry";
import HppEntry from "@/pages/HppEntry";
import SalesEntry from "@/pages/SalesEntry";
import ProjectionEntry from "@/pages/ProjectionEntry";
import ReportStock from "@/pages/ReportStock";
import ReportSales from "@/pages/ReportSales";
import ReportEta from "@/pages/ReportEta";
import ReportHpp from "@/pages/ReportHpp";
import ReportProjection from "@/pages/ReportProjection";
import StockAlerts from "@/pages/StockAlerts";
import ReportAccuracy from "@/pages/ReportAccuracy";

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center mono text-sm text-[#525252]">
        Memuat…
      </div>
    );
  if (!user) return <Login />;

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/entry/stock" element={<Guard roles={["logistik"]}><StockEntry /></Guard>} />
        <Route path="/entry/eta" element={<Guard roles={["purchasing"]}><EtaEntry /></Guard>} />
        <Route path="/entry/hpp" element={<Guard roles={["keuangan"]}><HppEntry /></Guard>} />
        <Route path="/entry/sales" element={<Guard roles={["sales"]}><SalesEntry /></Guard>} />
        <Route path="/entry/projection" element={<Guard roles={["cabang"]}><ProjectionEntry /></Guard>} />
        <Route path="/laporan/stock" element={<ReportStock />} />
        <Route path="/laporan/penjualan" element={<ReportSales />} />
        <Route path="/laporan/eta" element={<ReportEta />} />
        <Route path="/laporan/hpp" element={<Guard roles={["keuangan", "purchasing"]}><ReportHpp /></Guard>} />
        <Route path="/laporan/proyeksi" element={<ReportProjection />} />
        <Route path="/peringatan-stock" element={<StockAlerts />} />
        <Route path="/laporan/akurasi" element={<ReportAccuracy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
